import { DragEndEvent, UniqueIdentifier } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";
import { Dispatch, SetStateAction } from "react";

export const updateStateOnDragEnd = <T extends UniqueIdentifier>(
    event: DragEndEvent,
    setData: Dispatch<SetStateAction<Array<T>>>
) => {
    const { active, over } = event;

    if (over && active.id !== over.id) {
        setData((prevItems) => {
            const oldIndex = prevItems.findIndex((item) => item === active.id);
            const newIndex = prevItems.findIndex((item) => item === over.id);
            return arrayMove(prevItems, oldIndex, newIndex);
        });
    }
};
